module.exports = __webpack_public_path__ + "static/media/Stores.fc8cae41.jpg";